export default "__VITE_ASSET__9d23b7a0__"